import { apiFetch, readJson, type GetToken } from '@/lib/api/client'
import type {
  AdminFeedback,
  AdminListing,
  AdminReport,
  ResolveCheckAction,
  ResolveReportAction,
} from '@/lib/types/admin'

export function listAdminReports(getToken: GetToken): Promise<AdminReport[]> {
  return apiFetch('/api/admin/reports', { getToken }).then((response) =>
    readJson<AdminReport[]>(response),
  )
}

export function resolveAdminReport(
  id: string,
  action: ResolveReportAction,
  getToken: GetToken,
): Promise<AdminReport[]> {
  return apiFetch(`/api/admin/reports/${id}/resolve`, {
    method: 'POST',
    body: { action },
    getToken,
  }).then((response) => readJson<AdminReport[]>(response))
}

export function listAdminFeedback(
  getToken: GetToken,
): Promise<AdminFeedback[]> {
  return apiFetch('/api/admin/feedback', { getToken }).then((response) =>
    readJson<AdminFeedback[]>(response),
  )
}

export function listAdminChecks(getToken: GetToken): Promise<AdminListing[]> {
  return apiFetch('/api/admin/checks', { getToken }).then((response) =>
    readJson<AdminListing[]>(response),
  )
}

export function resolveAdminCheck(
  id: string,
  action: ResolveCheckAction,
  getToken: GetToken,
): Promise<AdminListing> {
  return apiFetch(`/api/admin/checks/${id}/resolve`, {
    method: 'POST',
    body: { action },
    getToken,
  }).then((response) => readJson<AdminListing>(response))
}
